import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-start;
  padding-left: 0;
  background-color: ${({ theme }) => theme.palette.backgrounds.tab};
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};

  @media (min-width: 768px) {
    display: flex;
    height: auto;
  }
`;
